<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create User</h1>
        </div>
        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="user-body">
                    <div class="form-field">
                        <label>First Name</label>
                        <input type="text" v-model="user.firstname" placeholder="First Name">
                    </div>
                    <div class="form-field">
                        <label>Last Name</label>
                        <input type="text" v-model="user.lastname" placeholder="Last Name">
                    </div>
                    <div class="form-field">
                        <label>Email</label>
                        <input type="email" v-model="user.email" placeholder="Email*">
                    </div>
                    <div class="form-field">
                        <label>Telephone</label>
                        <input type="text" v-model="user.telephone" placeholder="Telephone">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="flex">

                <div class="middle text-middle">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveUser">Save</button>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: 'UsersCreate',
        props: {},
        data() {
            return {
                user: {
                    firstname: null,
                    lastname: null,
                    email: null,
                    telephone: null,
                    container: 1,
                }
            }
        },
        mounted() {
            this.setMetaTitle('Create User | JournoLink Control')
        },
        beforeDestroy() {
            //
        },
        methods: {
            saveUser() {
                axios.post(route('users.store'), { "user": this.user }
                ).then(response => {
                    this.$bus.$emit('alert.success', 'User creation Success')
                    this.closeView();
                }).catch(e => {
                    console.log({e});
                });
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.$root.goBack()
            },
            addContainer(id){
                this.user.container = id;
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        },
        computed: {
            //
        }
    }
</script>

<style lang="less">

    .user-body {
        flex: 1;
        padding: 15px;
    }

</style>
